import { useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'
import { NextLinkFromReactRouter } from 'components/NextLink'
import { Menu as UikitMenu } from '@pancakeswap/uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { NetworkSwitcher } from 'components/NetworkSwitcher'

// import { usePriceCakeBusd } from 'state/farms/hooks'
// import { setPoolsData } from 'state/pools'
import { testnetTokens } from 'config/constants/tokens'
import { getAddress } from 'state/user/hooks'
import { getLpContract } from 'utils/contractHelpers'
import BigNumber from 'bignumber.js'
// import { AppState, useAppDispatch } from 'state'
// import { useSelector } from 'react-redux'
import { rp1PriceUsd } from 'state/farms/hooks'
import UserMenu from './UserMenu'
import { useMenuItems } from './hooks/useMenuItems'
import GlobalSettings from './GlobalSettings'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'
import { footerLinks } from './config/footerConfig'

const Menu = (props) => {
  const { isDark, setTheme } = useTheme()
  // const [cakePriceUsd, setCakePriceUsd] = useState(new BigNumber(0))
  // useEffect(() => {
  //   const pairAddress = getAddress(testnetTokens.rp1, testnetTokens.tusd)
  //   const contract = getLpContract(pairAddress)
  //   contract.getReserves().then((data) => {
  //     const reserve1 = data._reserve1.toString()
  //     const reserve0 = data._reserve0.toString()
  //     const price = new BigNumber(reserve1).div(new BigNumber(reserve0))
  //     setCakePriceUsd(price)
  //     return price
  //   })
  // }, [])
  const cakePriceUsd = rp1PriceUsd()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useRouter()

  const menuItems = useMenuItems()

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  return (
    <UikitMenu
      linkComponent={(linkProps) => {
        return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
      }}
      networkSwitcher={<NetworkSwitcher />}
      userMenu={<UserMenu />}
      globalMenu={<GlobalSettings />}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      cakePriceUsd={cakePriceUsd}
      links={menuItems}
      subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
      footerLinks={footerLinks(t)}
      activeItem={activeMenuItem?.href}
      activeSubItem={activeSubMenuItem?.href}
      buyCakeLabel={t('Buy')}
      {...props}
    />
  )
}

export default Menu
